function reScale(el: HTMLElement, pcHeight, originx, originy) {
  // 视口高度
  const { clientHeight, clientWidth } = document.documentElement;
  // 只在pc页面做缩放，其他尺寸通过media query做适配
  if (clientWidth > 750) {
    el.style.cssText = `transform: scale(${clientHeight / pcHeight}); transform-origin: ${originx} ${originy}`;
  }
}
export default function scaleEl(el, pcHeight = 1080, originx = '50%', originy = '0') {
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  // 按视口高度和设计稿高度比例缩放
  window.addEventListener(resizeEvt, () => {
    reScale(el, pcHeight, originx, originy);
  });
  document.addEventListener('DOMContentLoaded', () => {
    reScale(el, pcHeight, originx, originy);
  });
}
